import reactComponentLoader from 'scripts/react-component-loader'

import AddToCart from 'reactSite/Header/components/Cart/AddToCart'
import HeaderProviderMethods from 'reactSite/Header/providers/HeaderProviderMethods'

const ProviderAddCart = ({ children }) => (
  <HeaderProviderMethods>
    <AddToCart />
    {children}
  </HeaderProviderMethods>
)

reactComponentLoader(ProviderAddCart, '[data-add-to-cart]')
